import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { isAbove } from "./breakpoints.js";
// core version + navigation, pagination modules:
import Swiper, {
  Autoplay,
  Controller,
  EffectFade,
  Navigation,
  Pagination,
  Lazy,
} from "swiper";
// import Swiper and modules styles
import "swiper/scss";
import "swiper/scss/lazy";
import "swiper/scss/navigation";
import "swiper/scss/effect-fade";

Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade, Lazy]);

const usedIndexes = [];

$(window).on("load", function () {
  initializeSwipers();

  $(".js-menu-toggle").click(function () {
    $(this).toggleClass("toggled");
    $("body").toggleClass("modal-open");
    $(".js-mobile-menu").fadeToggle(300);
  });
});

function initializeSwipers() {
  // When initializingSwipers(), ignore the ones that are already initalized
  $(".swiper:not(.swiper-initialized )").each(function (index) {
    if ($(this).find(".swiper-slide").length <= 1) {
      $(this).addClass("single-slide");
      return;
    }

    var $this = $(this);
    let lastIndex = usedIndexes[usedIndexes.length - 1];

    if (typeof lastIndex === "undefined") {
      lastIndex = 0;
    } else {
      lastIndex += 1;
    }

    index = lastIndex;
    usedIndexes.push(index);

    $this.addClass("instance-" + index);
    $this
      .parent()
      .find(".swiper-button-next")
      .addClass("next-" + index);
    $this
      .parent()
      .find(".swiper-button-prev")
      .addClass("prev-" + index);
    $this
      .parent()
      .find(".swiper-pagination")
      .addClass("pagination-" + index);

    if ($this.hasClass("js-swiper-hero")) {
      const hero = new Swiper(".instance-" + index, {
        // Optional parameters
        effect: isAbove("md") ? "fade" : "slide", // Fade effect only on desktop
        speed: 700,
        rewind: true, // cycle last->first without cloning slides (loop clones break the index-based animation handlers)
        autoplay: {
          delay: 3500,
          disableOnInteraction: false, // keep looping after a manual click
        },
        fadeEffect: isAbove("md")
          ? {
              crossFade: true,
            }
          : undefined,
        allowTouchMove: !isAbove("md"), // Enable touch on mobile only
        noSwiping: isAbove("md"), // Disable swiping on desktop
        updateOnImagesReady: true,
        watchOverflow: true,
        lazy: true,
        loadPrevNext: true,
        loadOnTransitionStart: true,
        // If we need pagination
        pagination: {
          el: ".pagination-" + index,
          clickable: true,
        },

        on: {
          afterInit: function () {
            let currentIndex = this.activeIndex;
            currentIndex = currentIndex == -1 ? 0 : currentIndex;
            let $slide = $(this.slides[currentIndex]);

            setTimeout(function () {
              toggleAnimation($slide);
            }, 400);

            togglePaginationClass($slide);
            playVideo($slide);
          },
          slideChangeTransitionStart: function () {
            let currentIndex = this.previousIndex;
            currentIndex = currentIndex == -1 ? 0 : currentIndex;
            let $slide = $(this.slides[currentIndex]);
            let $nextSlide = $(this.slides[this.activeIndex]);
            toggleAnimation($slide);
            playVideo($nextSlide);
          },
          slideChangeTransitionEnd: function () {
            let currentIndex = this.activeIndex;
            currentIndex = currentIndex == -1 ? 0 : currentIndex;
            let $slide = $(this.slides[currentIndex]);
            pauseVideo($(this.slides[this.previousIndex]));
            toggleAnimation($slide);
          },
          realIndexChange: function () {
            let currentIndex = this.realIndex;
            currentIndex = currentIndex == -1 ? 0 : currentIndex;
            let $slide = $(this.slides[currentIndex]);
            togglePaginationClass($slide);
            loadVideo($slide);
            this.lazy.loadInSlide(currentIndex);
          },
        },
      });
    } else if ($this.hasClass("js-swiper-reviews")) {
      const reviews = new Swiper(".instance-" + index, {
        slidesPerView: 1,
        speed: 700,
        spaceBetween: 100,
        autoHeight: true,
        watchOverflow: true,
        // If we need pagination
        pagination: {
          el: ".pagination-" + index,
          clickable: true,
        },
      });
    } else if ($this.hasClass("js-swiper-gallery")) {
      const gallery = new Swiper(".instance-" + index, {
        slidesPerView: 1,
        speed: 700,
        spaceBetween: 0,
        watchOverflow: true,
        navigation: {
          nextEl: ".next-" + index,
          prevEl: ".prev-" + index,
        },
      });
    } else if ($this.hasClass("js-swiper-work")) {
      const gallery = new Swiper(".instance-" + index, {
        slidesPerView: 1,
        speed: 700,
        spaceBetween: 0,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return `
                        <div class="col-4 col-xl-3 col-xxl-2 col-spacing ${className}">
                        ${$(this.slides[index]).attr("data-img")}
</div>
                        `;
          },
        },
      });
    }
  });
}

const loadVideo = ($slide) => {
  let $video = $slide.find(".js-lazy-video");

  if ($video.length > 0) {
    $video.attr("src", $video.data("src"));
    $video.parent("video")[0].load();
    $video.parent("video")[0].play();
  }
};

const toggleAnimation = ($slide) => {
  let content = $slide.find(".js-swiper-content");
  if (!content.hasClass("animated")) {
    gsap.to(content, {
      opacity: 1,
      left: 0,
      ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
      duration: 1.1,
      onStart: () => {
        content.addClass("animated");
      },
    });
  } else {
    if (isAbove("md")) {
      gsap.to(content, {
        opacity: 0,
        left: -150,
        ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
        duration: 1.1,
        onStart: () => {
          content.removeClass("animated");
        },
      });
    }
  }
};

const pauseVideo = ($slide) => {
  let $video = $slide.find(".js-video");
  if ($video.length) {
    $video[0].pause();
  }
};

const playVideo = ($slide) => {
  let $video = $slide.find(".js-video");
  if ($video.length) {
    $video[0].play();
  }
};

const togglePaginationClass = ($slide) => {
  let $pagination = $slide.closest(".swiper").find(".swiper-pagination");
  if ($slide.hasClass("js-dark")) {
    $pagination.addClass("pagination--dark");
  } else {
    $pagination.removeClass("pagination--dark");
  }
};

$(document).on("click", ".js-open-gallery", function (e) {
  e.preventDefault();

  let popupInstance = newPopupInstance(".js-gallery");
  let $mainGallery = $(".js-swiper-work");
  let $popupGallery = $(".js-swiper-gallery-popup");
  let mainGallerySwiper = $mainGallery[0].swiper;
  let popupGallerySwiper = $popupGallery[0].swiper;

  popupGallerySwiper.slideTo(mainGallerySwiper.activeIndex);

  openPopup(popupInstance);
});

export { initializeSwipers };
